// @ts-nocheck
import {reactive} from 'vue';
import {sleep} from "../util/util";

export function useLoading(minTs?: number, initialValue?: boolean) {
  return reactive({
    value: initialValue || false,
    wrap(fn: Function) {
      const self = this;
      return async function () {
        try {
          self.value = true;
          const prom = fn(arguments);
          if (minTs && minTs > 0) {
            await sleep(minTs);
          }
          return await prom;
        }catch (e) {
          self.value = false;
          throw e;
        } finally {
          self.value = false;
        }
      }
    }
  })
}
